import React from "react";
import { Link } from "react-router-dom";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { CheckCircle, Calendar, Users, Mail, ArrowRight } from "lucide-react";

export default function RegistrationSuccess() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/10 to-accent/10 flex items-center justify-center p-4">
      <div className="max-w-2xl w-full space-y-8">
        {/* Success Header */}
        <div className="text-center space-y-4">
          <div className="mx-auto w-20 h-20 bg-success/10 rounded-full flex items-center justify-center">
            <CheckCircle className="w-12 h-12 text-success" />
          </div>
          <h1 className="text-3xl font-bold text-foreground">
            Welcome to the Team! 🎉
          </h1>
          <p className="text-lg text-foreground">
            Your registration was successful and we're excited to have you join
            us!
          </p>
        </div>

        {/* Main Content Card */}
        <Card className="shadow-lg">
          <CardHeader className="text-center">
            <CardTitle className="text-xl text-foreground">
              What happens next?
            </CardTitle>
            <CardDescription>
              Here's what you can expect in the coming days
            </CardDescription>
          </CardHeader>
          <CardContent className="space-y-6">
            {/* Step 1 */}
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                <Mail className="w-5 h-5 text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-foreground">
                  Check your email
                </h3>
                <p className="text-sm text-muted-foreground mt-1">
                  We've sent you a confirmation email with all the details you
                  need to know.
                </p>
              </div>
            </div>

            {/* Step 2 */}
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                <Users className="w-5 h-5 text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-foreground">
                  Admin will contact you
                </h3>
                <p className="text-sm text-muted-foreground mt-1">
                  One of our friendly admins will reach out soon to schedule
                  your onboarding session and answer any questions you might
                  have.
                </p>
              </div>
            </div>

            {/* Step 3 */}
            <div className="flex items-start space-x-4">
              <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-full flex items-center justify-center">
                <Calendar className="w-5 h-5 text-primary" />
              </div>
              <div className="flex-1">
                <h3 className="font-semibold text-foreground">
                  Start working events!
                </h3>
                <p className="text-sm text-muted-foreground mt-1">
                  After completing onboarding, you'll be able to sign in and
                  browse all the exciting casino events available for you to
                  work.
                </p>
              </div>
            </div>

            {/* Important Note */}
            <div className="bg-primary/5 border border-border rounded-lg p-4 mt-6">
              <p className="text-sm text-muted-foreground">
                <strong>Important:</strong> Your account is currently in a
                "Pending Approval" state. You won't be able to sign in until
                after your onboarding is complete, but don't worry - we'll get
                you set up and ready to go soon!
              </p>
            </div>

            {/* Action Buttons */}
            <div className="flex justify-center pt-4">
              <Link to="/signin">
                <Button variant="outline" className="px-8">
                  <ArrowRight className="w-4 h-4 mr-2" />
                  Already completed onboarding? Sign in here
                </Button>
              </Link>
            </div>
          </CardContent>
        </Card>

        {/* Footer Note */}
        <div className="text-center">
          <p className="text-sm text-muted-foreground">
            Questions? Issues? Feel free to reach out to our support team
            anytime.
          </p>
        </div>
      </div>
    </div>
  );
}
